"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const ContentMappingCreateInput_1 = require("./ContentMappingCreateInput");
const ContentMappingField_1 = require("./ContentMappingField");
let ContentMappingUpdateInput = class ContentMappingUpdateInput extends ContentMappingCreateInput_1.ContentMappingCreateInput {
    constructor() {
        super(...arguments);
        this.isArray = true;
        this.pathToArray = '';
        this.pathToTitle = '';
        this.pathToDate = '';
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", Boolean)
], ContentMappingUpdateInput.prototype, "isArray", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentMappingUpdateInput.prototype, "pathToArray", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentMappingUpdateInput.prototype, "pathToTitle", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentMappingUpdateInput.prototype, "pathToDate", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentMappingField_1.ContentMappingField], { nullable: true }),
    class_validator_1.ValidateNested(),
    tslib_1.__metadata("design:type", Array)
], ContentMappingUpdateInput.prototype, "fields", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], ContentMappingUpdateInput.prototype, "sampleContentFeedID", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [type_graphql_1.ID], { nullable: true }),
    tslib_1.__metadata("design:type", Array)
], ContentMappingUpdateInput.prototype, "conversionIds", void 0);
ContentMappingUpdateInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], ContentMappingUpdateInput);
exports.ContentMappingUpdateInput = ContentMappingUpdateInput;
//# sourceMappingURL=ContentMappingUpdateInput.js.map